module.exports = __webpack_public_path__ + "static/img/icon_star.dd8807b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join/icon_star.png
// module id = Ct92
// module chunks = 0